import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../app.config';
import {environment} from '../../environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  portalUrl: string = environment.main_url;
 // portalUrl: string = AppConfig.settings.apiServer.portalUrl;
  constructor() { }
 test: Date = new Date();
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/footer/footer.component.ts